import { toast } from "react-toastify";

export const message = (response) => {
    const options = {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
    };
    if (response.hasOwnProperty('success')) {
        if (response.success === true) {
            toast.success(response.message, options);
        } else {
            if (response.hasOwnProperty('error')) {
                const error = response.error;
                if (error.hasOwnProperty('errors')) {
                    // const array_errors = error.errors.splice(error.errors.length - 1);
                    const array_errors = error.errors;
                    array_errors.forEach(element => {
                        toast.error(element, options);
                    });
                } else {
                    toast.error(response.message || response.error, options);
                }
            } else {
                toast.error(response.message, options);
            }
        }
    } else {
        toast.error(response.message, options);
    }
}